import {ParameterValidator} from '@mvps-genesis/utilities';

export default class SearchFieldExtended {

	constructor () {
		this.validator = new ParameterValidator(this);

		this.searchInputs = this.validator.isElementList('.js-search-input', '.js-search-input');
		this.clearButtons = this.validator.isElementList('.js-clear-button', '.js-clear-button');
		this.typing = false;

		this.bindEvents();
	}

	bindEvents () {

		if (this.clearButtons.length) {
			for (const clearButton of this.clearButtons) {
				clearButton.addEventListener('click', () => this.clearForms(), false);
			}
		}

		if (this.searchInputs.length) {
			for (const searchInput of this.searchInputs) {
				searchInput.addEventListener('keyup', (e) => this.showClearButtons(searchInput, e), false);
				searchInput.addEventListener('mouseenter', (e) => this.showClearButtons(searchInput, e), false);
				searchInput.addEventListener('click', (e) => this.showClearButtons(searchInput, e), false);

				// On Page Inialization
				this.showClearButtons(searchInput);
			}
		}

	}

	showClearButtons (input, e) {

		for (const clearButton of this.clearButtons) {
			if (input.value.length > 0 && !clearButton.classList.contains('t-account-header__clear-button__active')) {
				clearButton.classList.add('t-account-header__clear-button__active');
			}
		}

		// Make it so all inputs match the same
		if (e && e.type === 'keyup' && input.value.length > 0 && this.typing === false) {
			this.typing = true;

			for (const searchInput of this.searchInputs) {
				if (searchInput === input) {
					continue;
				}

				searchInput.value = input.value;
			}

			this.typing = false;
		}

	};

	clearForms () {
		for (const searchInput of this.searchInputs) {
			searchInput.value = '';

			for (const clearButton of this.clearButtons) {
				clearButton.classList.remove('t-account-header__clear-button__active');
			}
		}
	}
}
